"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyPlusDrawNodesFO = exports.SankeyPlusNodeFO = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const d3 = __importStar(require("d3"));
const react_quill_1 = __importStar(require("react-quill"));
require("react-quill/dist/quill.snow.css");
const quill_image_resize_module_react_1 = __importDefault(require("quill-image-resize-module-react"));
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
react_quill_1.Quill.register('modules/imageResize', quill_image_resize_module_react_1.default);
const SankeyPlusNodeFO = (t, data, set_data, multi_selected_nodes, is_activated) => {
    // const [value, setValue] = useState('')
    const isAllFOVisible = () => {
        let visible = false;
        multi_selected_nodes.current.map(d => visible = (d.has_FO) ? true : visible);
        return visible;
    };
    const isAllFORaw = () => {
        let visible = false;
        multi_selected_nodes.current.map(d => visible = (d.is_FO_raw) ? true : visible);
        return visible;
    };
    const modules = {
        toolbar: [
            [{ 'font': [] }],
            [{ 'header': [1, 2, 3, 4, 5, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['image'],
            ['clean'],
        ],
        imageResize: {
            parchment: react_quill_1.Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize']
        }
    };
    const formats = ['font',
        'header', 'size',
        'bold', 'italic', 'underline', 'strike', 'color', 'background',
        'list', 'bullet', 'image', 'align'
    ];
    //Create 2 editor :
    // - one in an editor when we can apply layout width buttons
    // - one with raw html in case the editor can't do exactly what we want
    const editor_fo = react_1.default.createElement(react_quill_1.default, { value: multi_selected_nodes.current.length > 0 ? multi_selected_nodes.current[0].FO_content : '', 
        // onChange={(evt) => {
        //   Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
        //     d.FO_content =evt
        //   })
        // }}
        onBlur: () => { set_data(Object.assign({}, data)); }, theme: "snow", modules: modules, formats: formats, readOnly: !is_activated ? true : !isAllFOVisible() });
    const editor_fo_raw = react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 5, disabled: !is_activated ? true : !isAllFOVisible(), value: multi_selected_nodes.current.length > 0 ? multi_selected_nodes.current[0].FO_content : '', onChange: (evt) => {
            Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                d.FO_content = evt.target.value;
            });
            set_data(Object.assign({}, data));
        } });
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "node_fo", title: react_1.default.createElement(react_1.default.Fragment, null,
            t('Noeud.FO.FO'),
            " ",
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Beta")) },
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'foDisabled', placement: 'top', delay: 500, overlay: (!is_activated) ? (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'foDisabled' },
                t('Menu.sankeyPlusDisabled'),
                " ")) : react_1.default.createElement(react_1.default.Fragment, null) },
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (is_activated) ? '#555555' : '#DADADA' } }, t('Noeud.apparence.Visibilité'))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: isAllFOVisible(), disabled: !is_activated, onChange: evt => {
                                Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => d.has_FO = evt.target.checked);
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (is_activated) ? '#555555' : '#DADADA' } }, t('Noeud.apparence.raw'))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: isAllFORaw(), disabled: !is_activated, onChange: evt => {
                                Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => d.is_FO_raw = evt.target.checked);
                                set_data(Object.assign({}, data));
                            } }))),
                multi_selected_nodes.current.length > 0 ? react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row }, multi_selected_nodes.current[0].is_FO_raw ? editor_fo_raw : editor_fo) : react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.SankeyPlusNodeFO = SankeyPlusNodeFO;
const SankeyPlusDrawNodesFO = (data, mode_selection, nodeTooltipsContent) => {
    const node_mouse_over = (data, t, mode_selection, event, d, sankeyTooltip) => {
        d3.select(t).attr('cursor', (mode_selection === 's') ? 'pointer' : 'unset');
        if (SankeyUtils_1.node_displayed(data, d) && (window.SankeyToolsStatic || event.shiftKey)) {
            sankeyTooltip
                .style('opacity', 1)
                .html(nodeTooltipsContent(data, d));
        }
    };
    const node_mouse_move = (event, d, sankeyTooltip) => {
        if ((SankeyUtils_1.node_displayed(data, d)) && (window.SankeyToolsStatic || event.shiftKey)) {
            const h_tooltip = Number(sankeyTooltip.style('height').replace('px', ''));
            let pos_tooltip_y = event.clientY;
            const size_browser = window.innerHeight;
            pos_tooltip_y = ((h_tooltip + pos_tooltip_y) > size_browser) ? event.pageY + (size_browser - (pos_tooltip_y + h_tooltip)) - 5 : event.pageY;
            const w_tooltip = Number(sankeyTooltip.style('width').replace('px', ''));
            let pos_tooltip_x = event.clientX;
            const size_browser_w = window.innerWidth;
            pos_tooltip_x = ((w_tooltip + pos_tooltip_x) > size_browser_w) ? event.pageX - w_tooltip - 30 : event.pageX + 30;
            sankeyTooltip
                .style('top', pos_tooltip_y + 'px')
                .style('left', pos_tooltip_x + 'px');
        }
    };
    const add_nodes_fo = () => {
        //----------------ICON-----------------
        // Add icon to node (if there is one associated to it)
        // then apply selected parameter
        const sankeyTooltip = d3.select('div.sankey-tooltip');
        const ggg_nodes = d3.selectAll('.ggg_nodes');
        ggg_nodes.filter((d) => {
            return d.has_FO;
        }).append('foreignObject')
            .attr('width', (n) => +d3.select(' .opensankey #' + n.idNode).attr('width'))
            .attr('height', (n) => +d3.select(' .opensankey #' + n.idNode).attr('height'))
            .attr('id', (d) => d.idNode + '_fo')
            .on('mouseover', function (event, d) {
            node_mouse_over(data, this, mode_selection, event, d, sankeyTooltip);
        })
            .on('mousemove', function (event, d) {
            node_mouse_move(event, d, sankeyTooltip);
        })
            .on('mouseout', function () {
            sankeyTooltip.style('opacity', 0);
        })
            .append('xhtml:div')
            .html((d) => d.FO_content);
    };
    add_nodes_fo();
};
exports.SankeyPlusDrawNodesFO = SankeyPlusDrawNodesFO;
